module.exports = __webpack_public_path__ + "img/stan-sticker.6bdd946.png";